// Generated by ReScript, PLEASE EDIT WITH CARE

import * as JsxRuntime from "react/jsx-runtime";
import * as BsCssJs$PrezzeeRibbon from "../../../bindings/BsCss/BsCssJs.bs.js";
import * as Theme__Responsive$PrezzeeRibbon from "../../../theme/Theme__Responsive.bs.js";

var imageContainer = BsCssJs$PrezzeeRibbon.style([
      BsCssJs$PrezzeeRibbon.boxSizing("borderBox"),
      BsCssJs$PrezzeeRibbon.justifyContent("center"),
      BsCssJs$PrezzeeRibbon.media(Theme__Responsive$PrezzeeRibbon.tabletSmUp, [
            BsCssJs$PrezzeeRibbon.display("flex"),
            BsCssJs$PrezzeeRibbon.justifyContent("flexEnd"),
            BsCssJs$PrezzeeRibbon.marginTop(BsCssJs$PrezzeeRibbon.rem(2)),
            BsCssJs$PrezzeeRibbon.marginBottom(BsCssJs$PrezzeeRibbon.rem(2))
          ]),
      BsCssJs$PrezzeeRibbon.media(Theme__Responsive$PrezzeeRibbon.tabletOrDesktop, [
            BsCssJs$PrezzeeRibbon.flexGrow(0),
            BsCssJs$PrezzeeRibbon.flexShrink(0),
            BsCssJs$PrezzeeRibbon.flexBasis(BsCssJs$PrezzeeRibbon.pct(50))
          ]),
      BsCssJs$PrezzeeRibbon.media(Theme__Responsive$PrezzeeRibbon.desktop, [
            BsCssJs$PrezzeeRibbon.flexGrow(1),
            BsCssJs$PrezzeeRibbon.flexShrink(1),
            BsCssJs$PrezzeeRibbon.flexBasis("auto"),
            BsCssJs$PrezzeeRibbon.justifyContent("center")
          ]),
      BsCssJs$PrezzeeRibbon.media(Theme__Responsive$PrezzeeRibbon.tabletSm, [BsCssJs$PrezzeeRibbon.marginTop(BsCssJs$PrezzeeRibbon.px(31))]),
      BsCssJs$PrezzeeRibbon.selector("img", [
            BsCssJs$PrezzeeRibbon.display("block"),
            BsCssJs$PrezzeeRibbon.maxWidth(BsCssJs$PrezzeeRibbon.px(544)),
            BsCssJs$PrezzeeRibbon.width(BsCssJs$PrezzeeRibbon.pct(100)),
            BsCssJs$PrezzeeRibbon.height("auto"),
            BsCssJs$PrezzeeRibbon.marginLeft("auto"),
            BsCssJs$PrezzeeRibbon.marginRight("auto"),
            BsCssJs$PrezzeeRibbon.marginBottom("auto")
          ])
    ]);

var Style = {
  imageContainer: imageContainer
};

function TheGiftExperience__ImageContainer(props) {
  return JsxRuntime.jsx("div", {
              children: props.children,
              className: imageContainer
            });
}

var make = TheGiftExperience__ImageContainer;

export {
  Style ,
  make ,
}
/* imageContainer Not a pure module */
